import { ExploreFilterComponentProps } from "@modules/new-explore/types";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import { EXPLORE_CERTIFICATE } from "types/api/explore";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";
import { Switch } from "@shared/components/switch";
import { SWITCH_SIZES } from "@shared/components/switch/types";

const ExploreCertificateStatus: React.FC<ExploreFilterComponentProps> = () => {
  const { addFilter, removeFilterByKey } = useExplore();

  const { activeFilters } = useExplorePreloadedData();
  const selectedActiveFilter = activeFilters?.certificate?.filter_value || [];
  const activeCertificate = selectedActiveFilter?.[0]?.id;

  const checked = activeCertificate === EXPLORE_CERTIFICATE.WITH;

  const handleOnChange = async () => {
    if (!checked)
      addFilter({
        filterName: "certificate",
        value: EXPLORE_CERTIFICATE.WITH,
        name: "دارای گواهینامه",
        isSingle: true,
        withReplace: true,
      });
    else removeFilterByKey("certificate");
  };

  return (
    <div className="flex justify-between items-center">
      <p className="title-md-demibold text-fds-primary">فقط دارای گواهینامه</p>
      <Switch
        size={SWITCH_SIZES.LARGE}
        checked={checked}
        onClick={handleOnChange}
      />
    </div>
  );
};

export default ExploreCertificateStatus;
